import api from './client';

export const getSections = (projectId) => api.get('/sections', { params: { project: projectId } });
export const createSection = (data) => api.post('/sections', data);
export const updateSection = (id, data) => api.put(`/sections/${id}`, data);
export const deleteSection = (id) => api.delete(`/sections/${id}`);
